export default __webpack_public_path__ + "static/media/wish-icon.746efbd4.svg";